<template>
    <v-content>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md6 lg6 xl6 style="text-align: center;">
                    <v-card class="elevation-1 pa-3" v-if="step==0">
                        <v-card-text style="text-align: center">
                            <h3>{{$t("lang.class.classInfo")}}</h3>
                            <v-form @keyup.enter.native="onSave">
                                <i-upload :label="$t('lang.teacher.avatar')"
                                          v-model="clazz.avatarId"
                                          file-type="avatar"
                                          :multifile="false"
                                          name="avatarId"
                                          :data-vv-as="$t('lang.teacher.avatar')"
                                          :error-messages="errors.first('avatarId')"
                                />
                                <v-text-field  v-validate="'required'"
                                              :label="$t('lang.class.className')" type="text"
                                              v-model="clazz.className"
                                              maxlength="200"
                                              name="className"
                                              :data-vv-as="$t('lang.class.className')"
                                              :error-messages="errors.first('className')"
                                ></v-text-field>
                                <v-text-field
                                              v-if="clazz.classId != undefined && clazz.classId != null"
                                              :label="$t('lang.class.classCode')" type="text" readonly disabled
                                              v-model="clazz.classCode"
                                              name="classCode"
                                              :error-messages="errors.first('classCode')"
                                ></v-text-field>
                                <v-text-field
                                        v-if="clazz.classId != undefined && clazz.classId != null"
                                        :label="$t('lang.class.teacherName')" type="text" readonly disabled
                                        v-model="clazz.teacherName"
                                        name="teacherName"
                                        :error-messages="errors.first('teacherName')"
                                ></v-text-field>
                                <v-select v-validate="'required'"
                                          :label="$t('lang.class.grade')" type="text"
                                          v-model="clazz.gradeId"
                                          name="grade"
                                          :data-vv-as="$t('lang.class.grade')"
                                          :items="grades"
                                          item-text="grade_name"
                                          item-value="grade_id"
                                          @change="reloadClassBlock"
                                          :error-messages="errors.first('grade')"
                                ></v-select>
                                <v-select v-validate="'required'"
                                          :label="$t('lang.class.classBlock')" type="text"
                                          v-model="clazz.classBlockId"
                                          name="classBlock"
                                          :data-vv-as="$t('lang.class.classBlock')"
                                          :items="classBlocks"
                                          item-text="name"
                                          item-value="class_block_id"
                                          @change="reloadDescipline"
                                          :error-messages="errors.first('classBlock')"
                                ></v-select>
                                <v-select v-validate="'required'"
                                          :label="$t('lang.class.discipline')" type="text"
                                          v-model="clazz.disciplineId"
                                          name="discipline"
                                          :data-vv-as="$t('lang.class.discipline')"
                                          :items="disciplines"
                                          item-text="name"
                                          item-value="subject_id"
                                          :error-messages="errors.first('discipline')"
                                ></v-select>
                                <!--v-select v-validate="'required'"
                                          :label="$t('lang.class.subject')"
                                          v-model="clazz.subjectId"
                                          name="subject"
                                          :data-vv-as="$t('lang.class.subject')"
                                          :items="subjects"
                                          item-text="categoryName"
                                          item-value="categoryId"
                                          :error-messages="errors.first('subject')"

                                ></v-select-->
                                <v-text-field
                                        v-if="clazz.classId != undefined && clazz.classId != null"
                                        :label="$t('lang.class.schoolName')" type="text" readonly disabled
                                        v-model="clazz.schoolName"
                                        name="schoolName"
                                        :error-messages="errors.first('schoolName')"
                                ></v-text-field>
                                <v-textarea v-validate="'required'"
                                            :label="$t('lang.class.description')" type="text"
                                            v-model="clazz.description"
                                            maxlength="500"
                                            name="description"
                                            :data-vv-as="$t('lang.class.description')"
                                            :error-messages="errors.first('description')"
                                ></v-textarea>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="cancel" @click="cancel">
                                <!--v-icon dark left>cancel</v-icon-->
                                {{ $t('lang.common.cancel') }}
                            </v-btn>
                            <v-btn class="yoprimary" dark @click="onSave">
                                <!--v-icon dark left>create</v-icon-->
                                {{$t('lang.common.save')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                    <v-card class="elevation-1 pa-3" v-else>
                        <v-card-text style="text-align: center">
                            <h3>Mời giáo viên vào lớp</h3>
                            <div>Bạn vừa tạo lớp học thành công!
                                <br/>
                                Hãy mời giáo viên giảng dạy cho lớp học.
                            </div>
                            <v-data-table key="select_teacher" :headers="teacherSelectHeaders"
                                          :items="lstSelectTeacher"
                                          class="elevation-1" hide-actions>
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">{{ props.index+1 }}</td>
                                    <td class="text-xs-left">{{ props.item.teacherName }}</td>
                                    <td class="text-xs-left">{{ props.item.email }}</td>
                                    <td class="text-xs-left">{{ props.item.phone }}</td>
                                    <td class="justify-center">
                                        <input :key="props.item.studentId" class="tableInput" type="checkbox"
                                               v-model="props.item.selected" @change="changeSelect(props.item)"/>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="toClass" class="primaryColor">
                                Hủy
                            </v-btn>
                            <v-btn class="yoprimary" dark @click="onAddToClass">
                                <!--v-icon dark left>create</v-icon-->
                                Mời vào lớp
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
    import {message} from '../../services';
    import IDatepicker from "../../components/form/DatePicker";
    import axios from "axios"
    import IUpload from "../../components/form/Upload";

    export default {
        name: "clazz-create",
        components: {
            IUpload,
            IDatepicker,
        },

        data() {
            return {
                step:0,
                clazz: {
                    avatarId:1
                },
                subjects: [],
                grades: [],
                classBlocks: [],
                disciplines: [],
                orderBy:null,
                classId:null,
                teacher:{},
                teacherSelectHeaders: [
                    {
                        text: "STT",
                        align: "center",
                        sortable: false,
                        value: "name",
                        width: "10%"
                    },
                    {
                        text: "Họ và tên",
                        align: "left",
                        sortable: false,
                        value: "name",
                        width: "25%"
                    },
                    {
                        text: "Email",
                        align: "left",
                        sortable: false,
                        value: "email",
                        width: "25%"
                    },
                    {
                        text: "SĐT",
                        align: "left",
                        sortable: false,
                        value: "phone",
                        width: "25%"
                    },
                    {
                        text: "Chọn",
                        value: "name",
                        align: "left",
                        sortable: false,
                        width: "15%"
                    }
                ],
                lstSelectTeacher:[],
            }
        },

        created() {
            if (this.$route.params.classId) {
                let classId = this.$route.params.classId;
                ////console.log(this.$route.params.classId);
                axios.post(process.env.VUE_APP_API_URL + "/class/getClass?classId=" + classId).then(
                    data => {
                        this.clazz = data;
                        this.reloadClassBlock();
                        this.reloadDescipline();
                    },
                    error => {
                        //console.log(error);
                    }
                );
            } else{}


/*
            axios.post(process.env.VUE_APP_API_URL + "/category/listByType?type=SUBJECT").then(
                data => {
                    this.subjects = data;
                },
                error => {
                    //console.log(error);
                }
            )
*/
            axios.get(process.env.VUE_APP_YO_LEARN_API + "/grade").then(
                data => {
                    this.grades = data.data;
                },
                error => {
                    //console.log(error);
                }
            )
        },

        methods: {
            reloadClassBlock: function () {
                if (this.clazz.gradeId == undefined || this.clazz.gradeId == null) {
                    this.classBlocks = [];
                    return;
                }
                axios.get(process.env.VUE_APP_YO_LEARN_API + "/class_blocks?grade_id=" + this.clazz.gradeId).then(
                    data => {
                        this.classBlocks = data.data;
                    },
                    error => {
                        //console.log(error);
                    }
                )
            },
            reloadDescipline: function () {
                if (this.clazz.classBlockId == undefined || this.clazz.classBlockId == null) {
                    this.disciplines = [];
                    return;
                }
                axios.get(process.env.VUE_APP_YO_LEARN_API + "/subjects?class_block_id=" + this.clazz.classBlockId).then(
                    data => {
                        this.disciplines = data.data;
                    },
                    error => {
                        //console.log(error);
                    }
                )
            },
            onSave() {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    for(let i=0;i<this.disciplines.length;i++){
                        if(this.disciplines[i].subject_id == this.clazz.disciplineId){
                            this.clazz.disciplineName  = this.disciplines[i].name;
                            break;
                        }
                    }
                    for(let i=0;i<this.classBlocks.length;i++){
                        if(this.classBlocks[i].class_block_id == this.clazz.classBlockId){
                            this.clazz.classBlockName  = this.classBlocks[i].name;
                            break;
                        }
                    }
                    axios.post(process.env.VUE_APP_API_URL + "/class/save", this.clazz).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.save_success"));
                                if (this.clazz.classId != null && this.clazz.classId != undefined) {
                                    this.$router.go(-1);
                                } else {
                                    this.classId = data.id;
                                    this.initTeacher();
                                    this.step = 1;
                                    //this.$router.push("ViewClass/" + data.id);
                                }
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    );
                });
            },
            cancel: function () {
                this.$router.go(-1);
            },
            initTeacher() {
                let url = process.env.VUE_APP_API_URL + "/school/teachers?";
                if (this.orderBy != null) {
                    url += "orderBy=" + this.orderBy;
                }
                axios
                    .post(url, this.teacher)
                    .then(
                        data => {
                            this.lstSelectTeacher = data;
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },
            onAddToClass() {
                let classIds = this.classId;
                let insertTeacher = [];
                for (let i = 0; i < this.lstSelectTeacher.length; i++) {
                    if (this.lstSelectTeacher[i].selected) {
                        insertTeacher.push(this.lstSelectTeacher[i]);
                    }
                }
                if (insertTeacher.length == 0 && insertTeacher.length == 0) {
                    message.error("Bạn chưa chọn giáo viên");
                    return;
                }

                axios
                    .post(process.env.VUE_APP_API_URL + "/school/inserMultiTeacherClass?classIds=" + classIds, insertTeacher)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Mời giáo viên thành công");
                                this.$router.push("ViewClass/" + this.classId);
                            } else {
                                message.error("Mời giáo viên không thành công");
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    );

            },

            toClass(){
                this.$router.push("ViewClass/" + this.classId);
            },

            changeSelect(item) {
                //let row = e.target.getAttribute("row");
                ////console.log(item.selected);
                if (item.selected) {
                    let arr = [];
                    for (let i = 0; i < this.lstSelectTeacher.length; i++) {
                        if (this.lstSelectTeacher[i].teacherId == item.teacherId) {
                            //console.log("check:" + i);
                            this.lstSelectTeacher[i].selected = true;
                        } else {
                            //console.log("uncheck:" + i);
                            this.lstSelectTeacher[i].selected = false;
                        }
                        arr.push(this.lstSelectTeacher[i]);
                    }
                    this.lstSelectTeacher = arr;
                }


            }


        }
    };
</script>

